import ZoomButton from "./ZoomButton";

export default ZoomButton;